import { Injectable, Injector } from '@angular/core';

import { Contactpersoon } from '../dto/contactpersoon';
import { CrudService, Filter } from '@mango/core';
import { Relatie } from '../dto/relatie';

@Injectable({ providedIn: 'root' })
export class ContactpersoonService extends CrudService<Contactpersoon> {

    constructor(injector: Injector) { super(Contactpersoon, injector); }
    
    getRelatieFilter(relatie: Relatie): Filter<Contactpersoon> {
        if (relatie != null) {
            return new Filter<Contactpersoon>(fb => [fb.equal("relatieID",relatie.id)]);
        }
        else {
            return new Filter<Contactpersoon>(fb => [fb.equal("relatieID",-1)]);
        }
    }

}
